export default class KillPigConfigVO {
    public OpenKillPig: boolean = false;
    /**
     * 头部保留轮
     */
    public HeaderReserveJuNumber: number = 1;
    /**
     * 搜索索引
     */
    public SearchStartIndex: number = 0;
    /**
     * 忽略轮
     */
    public IgnoreJuNumber: number = 1;
    /**
     * 尾部保留轮
     */
    public EndReserveJuNumber: number = 2;
    /**
     * 多少钱开始启用
     * 0不限制
     */
    public KillStartAmount: number = 0;
    /**
     * 主播搜索启动范围(默认1)
     */
    public DealerSearchStartRange: number = 1;
    /**
     * 新批次不干预
     */
    public SkipKillInNewGame: boolean = true;

    /**
     * 自动下注（真实下注）总开关，默认关闭；由遥控器“服务配置-保存”在内存中开启，重启后回到关闭
     */
    public AutoBetEnabled: boolean = false;
    /**
     * 自动下注间隔（分钟），默认 8
     */
    public AutoBetIntervalMin: number = 8;
    /**
     * 自动下注单注金额（庄或闲单边），默认 100
     */
    public AutoBetAmount: number = 100;

    /**
     * 拉取数据总开关：控制是否连接上游 WebSocket（接收游戏/视频链接数据）以及是否拉取并自动重试视频链接。
     * 默认开启；由遥控器“服务配置-保存”在内存中控制。关闭后断开全部数据连接，等待再次开启。
     */
    public PullDataEnabled: boolean = true;

    /**
     * 真实服务器账号余额（来自自动下注连接的 onUserInfo，实时刷新），仅供遥控器展示
     */
    public RealServerBalance: number = 0;

    /**
     * 遥控器调整账号金额后，是否向该账号的在线客户端推送最新余额（走打赏 onGiveTips 通道）。
     * 默认关闭：调额仅落库，客户端需重新登录才看到新余额；开启后即时推送使其余额实时刷新。
     */
    public PushBalanceOnAdjust: boolean = false;

    /**
     * 新账号首次入库时是否把上游当前余额写入数据库。默认开启；关闭后新账号余额置 0 入库。
     */
    public SaveNewUserBalance: boolean = true;
}